import React, { memo } from 'react'

const Loading = () => {

    return (
        <article className="vh-100 d-flex justify-content-center align-items-center loading-container">
            <div className="spinner-border custom-spinner" role="status">
            </div>
        </article>
    )
}

export default memo(Loading);

